<template>
    <Head title="Letter Of Contract"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <Button
                            label="Buat PKWT"
                            icon="pi pi-envelope"
                            class="p-button-primary mr-2"
                            @click="showNewDialog"
                        />
                    </template>
                    <template v-slot:end>
                        <Button
                                label="Print Surat"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                @click="exportDetailToPdf"
                                :loading="isExporting"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage PKWT</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="id"
                        header="ID"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="pkwt_no"
                        header="No PKWT"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.pkwt_no }}
                        </template>
                    </Column>
                    <Column
                        field="pkwt_date"
                        header="Tanggal PKWT"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.pkwt_date }}
                        </template>
                    </Column>
                    <Column
                        field="employee_name"
                        header="Karyawan"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.employee_name }}
                        </template>
                    </Column>
                    <Column
                        field="placement_name"
                        header="Penempatan"
                        :sortable="true"
                        headerStyle="width:30%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            {{ slotProps.data.placement_name }}
                        </template>
                    </Column>

                    <Column headerStyle="width:20%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-eye"
                                class="mr-2"
                                @click="showDetail(slotProps.data.id)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
    },
    data() {
        return {
            searchFilter: "",
            filters: {},
            lazyParams: {},
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            deleteModelDialog: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        showDetail(id){
            this.$inertia.get(`${this.$page.props.appUrl}letter/contracts/${id}`);
        },
        showNewDialog(){
            this.$inertia.get(`${this.$page.props.appUrl}letter/contracts/create`);
        },
        loadLazyData() {
            this.loading = true;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/letters/contracts/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        confirmDeleteModel(model){
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
            axios
                .delete(`${this.$page.props.appUrl}api/letters/contracts/` + this.model.id)
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Deleted",
                        life: 3000,
                    });
                    this.deleteModelDialog = false;
                    this.model = {};
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Data not deleted" + error,
                        life: 3000,
                    });
                });
        },
        exportDetailToPdf(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/letters/contracts/${rawObject.id}/export-detail`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','PKWT-'+ rawObject.pkwt_no +'.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
    },
};
</script>
<style scoped lang="scss">
@import "../../../../assets/demo/badges.scss";
</style>
